// extracted by mini-css-extract-plugin
export default {"trailsText":"img_trailsText__rA409","container":"img_container__l7X2Q","ticker":"img_ticker__3YCOf"};